import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, HttpClientModule } from '@angular/common/http'; // HttpClientModule can be imported here as well
import { NgxEchartsModule } from 'ngx-echarts';
import { EnvironmentService } from './services/enviroment.service'; // Adjust path if necessary
import { I18nService } from './services/i18n.service';

import * as echarts from 'echarts';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

 // Factory function for APP_INITIALIZER
  export function initializeAppFactory(envService: EnvironmentService): () => Promise<void> {
    return () => envService.loadEnvironmentConfig();
  }

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideAnimationsAsync(),
    importProvidersFrom(NgxEchartsModule.forRoot({echarts})),
    importProvidersFrom(HttpClientModule),
    EnvironmentService, // 提供服務本身
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory, // Corrected: Changed from initializeEnvironment to initializeAppFactory
      deps: [EnvironmentService],
      multi: true,
    },
    // 確保 I18nService 可在整個應用程序中使用
    { provide: I18nService }
  ]
};
